import React from 'react';
import { safeRest } from '../../utils/functions.js';
import { StyledImage } from './styledComponents.js';

var CardImage = function CardImage(props) {
  var safeProps = safeRest(props);
  return /*#__PURE__*/React.createElement(StyledImage, safeProps);
};
process.env.NODE_ENV !== "production" ? CardImage.displayName = 'CardImage' : void 0;
var CardImage$1 = CardImage;

export { CardImage$1 as default };
